import React, { Component } from "react";
import { toastrMessage } from "helpers/messageHelper";
import { SUCCESS, DANGER } from "constants/commonConstants";
import { formatLocalDate } from "helpers/generalUtils";

import {
  getUserDetailsRequest,
  updateUserStatusByUserIdRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeUserMgmtSelectField } from "store/UserMgmt/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";

const columns = [
  {
    label: "First Name",
    field: "firstName",
  },
  {
    label: "Last Name",
    field: "lastName",
  },
  {
    label: "Mobile No",
    field: "mobileNo",
  },
  {
    label: "Email",
    field: "email",
  },
  {
    label: "Date Of Birth",
    field: "dateOfBirth",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
];

class UserMgmtList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetailRecords: [],
    };
  }

  componentDidMount() {
    //Retrieve category list
    this.props.getUserDetailsRequest();
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateUserStatusByUserIdRequest(id, checked);
  };

  buildCategoryDataTable = (records) => {
    this.setState({
      userDetailRecords: records.map((user) => {
        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={user.userId + ""}
              checked={user.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          firstName: user.firstName,
          lastName: user.lastName,
          mobileNo: user.mobileNo,
          email: user.email,
          dateOfBirth: formatLocalDate(user.dateOfBirth),
          status: status,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.userDetailData &&
      this.props.userDetailData !== nextprops.userDetailData
    ) {
      this.buildCategoryDataTable(nextprops.userDetailData);
    }
    if (
      nextprops.userDetailApiResponse &&
      this.props.userDetailApiResponse !== nextprops.userDetailApiResponse
    ) {
      if (nextprops.userDetailApiResponse.isSuccessResponse) {
        this.props.getUserDetailsRequest();
        toastrMessage(nextprops.userDetailApiResponse.responseMessage, SUCCESS);
      } else if (!nextprops.userDetailApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.userDetailApiResponse.responseMessage, DANGER);
      }
    }
  }

  render() {
    const data = {
      columns: columns,
      rows: this.state.userDetailRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  userDetailData: makeUserMgmtSelectField("userDetailData"),
  userDetailApiResponse: makeUserMgmtSelectField("userDetailApiResponse"),
});

const withConnect = connect(mapStatetoProps, {
  getUserDetailsRequest,
  updateUserStatusByUserIdRequest,
});

export default compose(withConnect, withRouter)(UserMgmtList);
